import React from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';

import SummaryCard from './SummaryCard';

const PrescriptionSummary = ({
  prescription,
  onEdit,
  showEdit
}) => {
  if (!prescription?.medications?.length) {
    return null;
  }

  return (
    <SummaryCard
      title="Rx — Prescriptions"
      onEdit={onEdit}
      showEdit={showEdit}
    >
      <TableContainer>
        <Table
          sx={{
            tableLayout: 'fixed',

            '& .MuiTableCell-root': {
              height: 40,
              px: 2,
              py: 0,
              color: '#424242',
              fontSize: 12,
              borderBottom: '1px solid #F5F5F5'
            },

            '& .MuiTableBody-root .MuiTableRow-root:last-child .MuiTableCell-root': {
              borderBottom: 'none'
            }
          }}
        >
          <TableHead>
            <TableRow sx={{ bgcolor: '#FAFAFA' }}>
              <TableCell sx={{ width: '30%', fontWeight: 500 }}>
                MEDICATION
              </TableCell>

              <TableCell sx={{ fontWeight: 500 }}>
                DOSE
              </TableCell>

              <TableCell sx={{ fontWeight: 500 }}>
                DIRECTION
              </TableCell>

              <TableCell sx={{ fontWeight: 500 }}>
                QUANTITY
              </TableCell>

              <TableCell sx={{ fontWeight: 500 }}>
                REFILL
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {prescription.medications.map((medication, index) => (
              <TableRow
                key={medication.id || `${medication.name}-${index}`}
              >
                <TableCell>
                  {medication.name}
                </TableCell>

                <TableCell>
                  {medication.dosage}
                </TableCell>

                <TableCell>
                  {medication.directions}
                </TableCell>

                <TableCell>
                  {medication.quantity}
                </TableCell>

                <TableCell>
                  {medication.refill}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {prescription.comments && (
        <Box
          sx={{
            px: 2,
            py: 1,
            borderTop: '1px solid #F5F5F5'
          }}
        >
          <Typography
            sx={{
              mb: 0.5,
              color: '#4478B5',
              fontSize: 13,
              fontWeight: 600
            }}
          >
            Comments
          </Typography>

          <Typography
            sx={{
              color: '#616161',
              fontSize: 13,
              whiteSpace: 'pre-line'
            }}
          >
            {prescription.comments}
          </Typography>
        </Box>
      )}
    </SummaryCard>
  );
};

PrescriptionSummary.propTypes = {
  prescription: PropTypes.shape({
    medications: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([
          PropTypes.number,
          PropTypes.string
        ]),
        name: PropTypes.string,
        dosage: PropTypes.oneOfType([
          PropTypes.number,
          PropTypes.string
        ]),
        directions: PropTypes.string,
        quantity: PropTypes.oneOfType([
          PropTypes.number,
          PropTypes.string
        ]),
        refill: PropTypes.oneOfType([
          PropTypes.number,
          PropTypes.string
        ])
      })
    ),
    comments: PropTypes.string
  }),
  onEdit: PropTypes.func,
  showEdit: PropTypes.bool
};

PrescriptionSummary.defaultProps = {
  prescription: null,
  onEdit: () => {},
  showEdit: true
};

export default PrescriptionSummary;